import { useEffect, useState } from 'react';
import axios from 'axios';
import { FolderOpen, FileText, Download, Spinner } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Sprint C #15 — Documents chantier visibles entreprise
 */
export default function EntrepriseDocumentsList({ invitationId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API_URL}/api/entreprise/consultations/${invitationId}/documents`, { withCredentials: true })
      .then((r) => setItems(r.data?.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [invitationId]);

  return (
    <div className="border border-[#E0E0DB] bg-white p-4" data-testid="entreprise-docs-section">
      <div className="flex items-center gap-2 mb-3">
        <FolderOpen size={16} className="text-[#1E3A5F]" weight="duotone" />
        {/* A6 (P2#1) — le dossier de consultation : CCTP, DPGF, pièces choisies par l'architecte */}
        <h3 className="text-sm font-bold text-[#2C2C2C]">Dossier de consultation ({items.length})</h3>
        <span className="text-[10px] text-[#9A9A9A]">CCTP, cadre DPGF, plans et pièces jointes par l'architecte</span>
      </div>

      {loading && <Spinner size={20} className="animate-spin text-[#9A9A9A] mx-auto block" />}
      {!loading && items.length === 0 && (
        <p className="text-xs text-[#9A9A9A] italic" data-testid="entreprise-docs-empty">Aucun document partagé pour cette consultation.</p>
      )}
      {!loading && items.length > 0 && (
        <ul className="divide-y divide-[#F0F0EE] border border-[#E0E0DB]" data-testid="entreprise-docs-list">
          {items.map((d) => (
            <li key={d.id} className="px-3 py-2 flex items-center gap-2" data-testid={`entreprise-doc-${d.id}`}>
              <FileText size={14} className="text-[#9A9A9A] flex-shrink-0" />
              <span className="text-xs text-[#2C2C2C] flex-1 truncate">{d.nom}</span>
              {d.type && (
                <span className="text-[10px] uppercase tracking-wide text-[#9A9A9A] bg-[#F5F5F3] px-2 py-0.5">
                  {d.type}
                </span>
              )}
              {d.url && (
                <a
                  href={d.url.startsWith('http') ? d.url : `${API_URL}${d.url}`}
                  target="_blank" rel="noopener noreferrer"
                  className="text-[#1E3A5F] hover:text-[#152c46]"
                  title="Télécharger"
                  data-testid={`entreprise-doc-download-${d.id}`}
                >
                  <Download size={14} />
                </a>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
